import * as React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
import { useRouter } from 'hooks/useRouter'
// components
import ExitReportButton from 'components/CTAs/ExitReportButton'
import MainLayoutContainer from 'containers/MainLayout/index'
import { Container as ContainerOrigin } from '@mui/material'
// hooks
import { useSetPowerBIToken } from 'hooks/index'
// themes
import { colors } from 'themes'

const PowerBIReport = React.lazy(() => import('components/PageComponents/DataHub/Report/PowerBIReportCreate'))

const Container = styled(ContainerOrigin)`
  && {
    padding: 0;

    iframe {
      background-color: ${colors.white};
      height: calc(100vh - 64px) !important;
    }
  }
`

const NewReport: React.FC = () => {
  const router = useRouter()

  const token = useSetPowerBIToken({ workspaceId: router.query.workspaceId, isCreate: true })

  return (
    <>
      <Helmet>
        <title>Skefto - Report Create</title>
      </Helmet>
      <MainLayoutContainer isLoading={!token} label={'Report Create'} CTA={<ExitReportButton />}>
        <Container maxWidth={false}>
          <React.Suspense fallback={null}>
            <PowerBIReport
              accessToken={token}
              datasetId={router.query.datasetId as string}
              workspaceId={router.query.workspaceId as string}
            />
          </React.Suspense>
        </Container>
      </MainLayoutContainer>
    </>
  )
}

export default NewReport
